import React from "react"
import { Navigate, Outlet, useParams } from "react-router-dom"

import { VenueProvider } from "@/contexts/venue"
import { useStore } from "@/store"

import RedirectToSlug from "./redirect_to_slug"

const AuthArea: React.FC = () => {
  const { currentUser } = useStore()
  const { slug } = useParams()

  if (!currentUser) {
    return <Navigate to="/sign_in" replace />
  }

  const slugProp = slug || null

  return <VenueProvider slug={slugProp}>{slugProp ? <Outlet /> : <RedirectToSlug />}</VenueProvider>
}

export default AuthArea
